import React, { useCallback } from 'react'
import { useAppSelector } from '../../../store/hooks'
import { selectAccountId } from '../../../store/auth/authSlice'
import { selectCrossClientMatchedWithoutActionsCount, selectCrossClientResultsExecution } from '../../../store/crossClient/crossClientResults'
import { selectCrossClientActionedClientIds } from '../../../store/crossClient/crossClientActions'
import { CrossClientQueryResultMatches } from '../../../models/CrossClient'
import { useLazyGetAllCrossClientQueryExecutionResultsQuery } from '../../../store/crossClient/crossClient'
import { CrossClientChooseActionDropdown } from './CrossClientChooseActionDropdown'

export const CrossClientMatchActions: React.FC = () => {
  const accountId = useAppSelector(selectAccountId)
  const execution = useAppSelector(selectCrossClientResultsExecution)
  const withoutActions = useAppSelector(selectCrossClientMatchedWithoutActionsCount)
  const actionedClientIds = useAppSelector(selectCrossClientActionedClientIds)

  const [triggerGetAllResults] = useLazyGetAllCrossClientQueryExecutionResultsQuery()

  const resolveTargets = useCallback(async () => {
    if (!execution?.id) {
      return []
    }
    const response = await triggerGetAllResults({
      accountId,
      executionId: execution.id,
      match: [CrossClientQueryResultMatches.MATCH],
    }).unwrap()
    return response.data.filter((result) => !actionedClientIds.has(result.clientId))
  }, [accountId, execution, actionedClientIds, triggerGetAllResults])

  return <CrossClientChooseActionDropdown count={withoutActions} scope='recommended' resolveTargets={resolveTargets} />
}
